import {useState} from "react";
import useCountryAxiosInstance from "@hooks/useCountryAxiosInstance";
import {WorksitesSchema, WorksitesWithIdSchema} from "@feature/types";

export const useWorksites = () => {

  // hooks
  const countryApiRequest = useCountryAxiosInstance();

  // state
  const [submitting, setSubmitting] = useState(false);

  // handlers
  const upsert = async (id: number | null, worksite: WorksitesSchema) => {
    setSubmitting(true);
    try {
      const promise = id !== null
        ? countryApiRequest!.put(`/worksites/${id}`, worksite)
        : countryApiRequest!.post("/worksites", worksite);
      return await promise as unknown as WorksitesWithIdSchema;
    }
    finally {
      setSubmitting(false);
    }
  }
  const checkCountry = async (address: string, city: string) => {
    const promise = countryApiRequest!.get(
      "/get-address-country",{params: {address, city}}
    );
    return await promise as unknown as string;
  }

  return {submitting, upsert, checkCountry}
}